module.exports = __webpack_public_path__ + "static/media/edit_dest.61b36045.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/arrivaClick/images/edit_dest.svg
// module id = 550
// module chunks = 0